import { createAsyncThunk } from "@reduxjs/toolkit";
import { UsersAPI } from "api/api/usersApi/usersApi";
import axios from "axios";
import { PutMeUsersBody, PutMeUsersResponse } from "api/api/usersApi/types";

export const putMeUsers = createAsyncThunk<
  PutMeUsersResponse,
  PutMeUsersBody
>(
  "users/putMeUsers",
  async (body, { rejectWithValue }) => {
    try {
      const response = await UsersAPI.putMeUsers(body);
      return response.data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error("Error while updating user profile", error.response?.data);
        return rejectWithValue(error.response?.data || "Unknown error");
      }
      else {
        console.error("Error while updating user profile", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  })